// Camada de configuração da API. Enquanto o backend (PROJECT_FULL.MD) não existe,
// USE_MOCK_API fica true e os *Service.ts respondem com dados mockados via mockDelay().
// Quando a API real estiver disponível, basta setar REACT_APP_USE_MOCK_API=false e
// REACT_APP_API_BASE_URL — os hooks e componentes não mudam, só o miolo dos services.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? '/api';
export const USE_MOCK_API = (process.env.REACT_APP_USE_MOCK_API ?? 'true') !== 'false';
